export default __webpack_public_path__ + "static/media/columbus.801e16bf.jpeg";